var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPollIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.353 9.41223H11.2543C10.3037 9.41223 9.52588 10.19 9.52588 11.1406V23.2394C9.52588 24.19 10.3037 24.9678 11.2543 24.9678H23.353C24.3037 24.9678 25.0814 24.19 25.0814 23.2394V11.1406C25.0814 10.19 24.3037 9.41223 23.353 9.41223ZM13.8469 21.511C13.3716 21.511 12.9827 21.1221 12.9827 20.6468V16.3258C12.9827 15.8505 13.3716 15.4616 13.8469 15.4616C14.3222 15.4616 14.7111 15.8505 14.7111 16.3258V20.6468C14.7111 21.1221 14.3222 21.511 13.8469 21.511ZM17.3037 21.511C16.8283 21.511 16.4395 21.1221 16.4395 20.6468V13.7332C16.4395 13.2579 16.8283 12.869 17.3037 12.869C17.779 12.869 18.1679 13.2579 18.1679 13.7332V20.6468C18.1679 21.1221 17.779 21.511 17.3037 21.511ZM20.7604 21.511C20.2851 21.511 19.8962 21.1221 19.8962 20.6468V18.9184C19.8962 18.4431 20.2851 18.0542 20.7604 18.0542C21.2358 18.0542 21.6246 18.4431 21.6246 18.9184V20.6468C21.6246 21.1221 21.2358 21.511 20.7604 21.511Z",
    fill: "url(#paint0_linear_9491_32206)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9491_32206",
    x1: 25.062,
    y1: 9.5076,
    x2: 9.50647,
    y2: 23.7669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6FCC87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54B06C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPollIcon);
export default __webpack_public_path__ + "static/media/PollIcon.991a576a6c7648fcbf1ba35710788b2a.svg";
export { ForwardRef as ReactComponent };